import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Group, User } from '@rocksoft/security-sdk';

@Component({
  selector: 'era-security-search-bar',
  templateUrl: './user-search-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgSelectComponent],
})
export class UserSearchBarComponent {
  readonly multiSelect = input(false);
  readonly items = input<Group[] | User[]>();

  readonly selectedItem = output<Group | User>();

  modelChanged(model: Group | User) {
    this.selectedItem.emit(model);
  }
}
